export const domain = 'TermsAndConditions';

// action types
export const CLOSE_MODAL = `${domain}/CLOSE_MODAL`;
export const DESTROY_CUSTOMER_ID_AND_RESULT_CODE = `${domain}/DESTROY_CUSTOMER_ID_AND_RESULT_CODE`;
export const OPEN_MODAL = `${domain}/OPEN_MODAL`;
export const SET_CUSTOMER_ID = `${domain}/SET_CUSTOMER_ID`;
export const SET_MODAL_MESSAGE = `${domain}/SET_MODAL_MESSAGE`;
export const SET_MODAL_TITLE = `${domain}/SET_MODAL_TITLE`;
export const SET_RESULT_CODE = `${domain}/SET_RESULT_CODE`;
export const SET_PREVIOUS_APPLICATION_VALUES = `${domain}/SET_PREVIOUS_APPLICATION_VALUES`;
